<template>
  <div class="activity-logs-field">
    <v-expansion-panels>
      <v-expansion-panel @click="onPanelChange">
        <v-expansion-panel-header>活動報告</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div class="filter-area">
            <v-select
              v-model="selectedReportType"
              :items="reportTypes"
              label="活動内容フィルタ"
              outlined
              dense
              class="filter-select"
            >
            </v-select>
            <v-text-field
              v-model="searchForActivityReport"
              label="エピソード検索"
              outlined
              dense
              class="filter-text"
            ></v-text-field>
          </div>
          <v-data-table
            class="my-custom-table"
            :items="filteredActivityLogs"
            :headers="headers"
            :search="combinedSearch"
            :custom-filter="combinedFilter"
          ></v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>SOZOWコイン</v-expansion-panel-header>
        <v-expansion-panel-content>
          <div>
            <v-container>
              <v-row justify="center" align="center" class="my-4">
                <v-col cols="auto" class="text-center mx-8">
                  <div class="coin-label mb-1">持っている<br />SOZOWコイン</div>
                  <div class="d-flex align-center justify-center">
                    <span class="coin-number">{{
                      sozowCoinCredit.amount
                    }}</span>
                    <span class="coin-unit">枚</span>
                  </div>
                </v-col>
                <v-col cols="auto" class="text-center mx-8">
                  <div class="coin-label mb-1">今週送れる<br />SOZOWコイン</div>
                  <div class="d-flex align-center justify-center">
                    <span class="coin-number">{{
                      sozowCoinCredit.tmp_amount
                    }}</span>
                    <span class="coin-unit">枚</span>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-data-table
              class="my-custom-table"
              :items="sozowCoinSentAndReceiptLogs"
              :headers="headersForSozowCoinSentAndReceiptLogs"
            ></v-data-table>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <!--      開発中のためコメントアウト-->
      <!--      <v-expansion-panel>-->
      <!--        <v-expansion-panel-header-->
      <!--          >交流チャット（Slack）-->
      <!--        </v-expansion-panel-header>-->
      <!--        <v-expansion-panel-content>-->
      <!--          <Chart :data="numberOfPostsOnSlack"></Chart>-->
      <!--        </v-expansion-panel-content>-->
      <!--      </v-expansion-panel>-->
      <!--      <v-expansion-panel>-->
      <!--        <v-expansion-panel-header>30秒アンケート</v-expansion-panel-header>-->
      <!--        <v-expansion-panel-content>-->
      <!--          <div>{{ thirtySecondSurveys }}</div>-->
      <!--        </v-expansion-panel-content>-->
      <!--      </v-expansion-panel>-->
    </v-expansion-panels>
  </div>
</template>

<style scoped lang="scss">
.activity-logs-field {
  padding: 0 10px;
}

.v-expansion-panel-header {
  font-weight: bold;
}

.filter-area {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.filter-select {
  max-width: 200px;
}

.coin-label {
  color: #6b7aff;
  font-size: 0.875rem;
  line-height: 1.4;
  font-weight: 400;
}

.coin-number {
  color: #6b7aff;
  font-size: 3rem;
  font-weight: 300;
  line-height: 1;
}

.coin-unit {
  color: #6b7aff;
  font-size: 1rem;
  margin-left: 0.5rem;
  margin-bottom: 1.5rem;
  font-weight: 400;
}
</style>

<style lang="css">
/*noinspection CssUnusedSymbol*/
td.episode-header {
  flex-direction: column !important; /* 縦に並べる */
  align-items: flex-start !important; /* 左寄せにする */
  justify-content: flex-start !important;
  border-bottom: solid rgba(0, 0, 0, 255) !important;
  border-bottom-width: 1px !important;
  margin: 10px 0;
}

/*noinspection CssUnusedSymbol*/
td.v-data-table__mobile-row {
  justify-content: start !important;
}

/*noinspection CssUnusedSymbol*/
div.episode-cell {
  margin-bottom: 20px;
}

/*noinspection CssUnusedSymbol*/
div.v-data-table__mobile-row__header {
  min-width: 60px;
}

/*noinspection CssUnusedSymbol*/
div.v-data-table__mobile-row__cell {
  text-align: left !important;
}
</style>

<script lang="ts">
import Vue from "vue";
import {
  ActivityLog,
  SozowCoinSentAndReceivedLog,
  SozowCoinCredit,
  NumberOfPostsOnSlack,
} from "@/types/user";
// import Chart from "@/views/MyPage/components/Chart.vue";

export default Vue.extend({
  components: {
    // Chart
  },
  props: {
    userId: {
      type: String,
      required: true,
    },
    activityLogs: {
      type: Array as () => ActivityLog[],
      required: false,
      default: () => [],
    },
    sozowCoinCredit: {
      type: Object as () => SozowCoinCredit,
      required: true,
    },
    sozowCoinSentAndReceivedLogs: {
      type: Array as () => SozowCoinSentAndReceivedLog[],
      required: false,
      default: () => [],
    },
    numberOfPostsOnSlack: {
      type: Array as () => NumberOfPostsOnSlack[],
      required: true,
      default: () => [],
    },
    thirtySecondSurveys: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      selectedReportType: "",
      target: "",
      searchForActivityReport: "",
      reportTypes: [
        "1on1",
        "1on1未実施報告",
        "NonN",
        "探Q",
        "ガクサポ",
        "zoom出席",
        "通学コース",
        "レク",
        "スタッフ探Q",
        "その他",
        "ライブ_ファイナルミッション",
        "プロ活",
        "コーチ活動",
        "イベント",
        "保護者面談",
      ],
      headers: [
        {
          text: "日付",
          value: "subject_date",
        },
        {
          text: "ニックネーム",
          value: "nickname",
        },
        {
          text: "役割",
          value: "editor_role",
        },
        {
          text: "活動内容",
          value: "report_type",
        },
        {
          text: "エピソード",
          value: "episode",
        },
      ],
      headersForSozowCoinSentAndReceiptLogs: [
        {
          text: "日付",
          value: "date",
        },
        {
          text: "相手",
          value: "nickname",
        },
        {
          text: "メッセージ",
          value: "message",
        },
        {
          text: "枚数",
          value: "numOfCoins",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.addEpisodeClass();
    });

    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  updated() {
    this.$nextTick(() => {
      this.addEpisodeClass();
    });
  },
  computed: {
    combinedSearch(): string {
      const t = this.target !== "" ? this.target : undefined;
      const s =
        this.selectedReportType !== "" ? this.selectedReportType : undefined;

      return `${t} ${s}`;
    },

    filteredActivityLogs(): Array<any> {
      return this.activityLogs.filter((item: any) => {
        const matchesType =
          this.selectedReportType === "" ||
          item.report_type === this.selectedReportType;
        const matchesSearch =
          this.searchForActivityReport === "" ||
          (item.episode &&
            item.episode
              .toLowerCase()
              .includes(this.searchForActivityReport.toLowerCase()));

        return matchesType && matchesSearch;
      });
    },

    sozowCoinSentAndReceiptLogs(): Array<any> {
      const results = [];

      for (const log of this.sozowCoinSentAndReceivedLogs) {
        const modifiedLog: SozowCoinSentAndReceivedLog = { ...log };
        if (modifiedLog.sender_member_id === this.userId) {
          const numOfCoins = "- " + `${modifiedLog.send_tmp_amount}`;

          results.push({
            date: modifiedLog.send_dt,
            nickname: modifiedLog.receiver_nickname,
            message: modifiedLog.message,
            numOfCoins: numOfCoins,
          });

          continue;
        }

        results.push({
          date: modifiedLog.send_dt,
          nickname: modifiedLog.sender_nickname,
          message: modifiedLog.message,
          numOfCoins: "+ " + `${modifiedLog.send_tmp_amount}`,
        });
      }

      return results;
    },
  },
  methods: {
    onPanelChange(isOpen: boolean) {
      if (isOpen) {
        setTimeout(() => {
          this.addEpisodeClass();
        }, 100); // Vueのレンダリングを確実に終わらせる
      }
    },
    combinedFilter(_value: any, target: string, item: any) {
      const [text, reportType] = target.split(" ");

      // split()の戻り値が文字列であるため
      if (text !== "undefined") {
        if (reportType !== "undefined") {
          return (
            item.episode?.toLowerCase().includes(text.toLowerCase()) &&
            item.report_type === reportType
          );
        }

        return item.episode?.toLowerCase().includes(text.toLowerCase());
      }

      if (reportType !== "undefined") {
        if (text !== "undefined" && text !== null) {
          return (
            item.report_type === reportType &&
            item.episode?.toLowerCase().includes(String(text).toLowerCase())
          );
        }

        return item.report_type === reportType;
      }

      return true;
    },
    handleResize() {
      // 幅が 768px 以下なら addEpisodeClass を呼ぶ
      if (window.innerWidth <= 768) {
        this.$nextTick(() => {
          this.addEpisodeClass();
        });
      }
    },
    addEpisodeClass() {
      const expansionPanelContents =
        this.$el.querySelectorAll(".v-expansion-panel");

      expansionPanelContents.forEach((dom: Element) => {
        const headline = dom.querySelector(".v-expansion-panel-header");
        if (headline && headline.textContent?.trim() !== "活動報告") {
          return;
        }

        const row = dom.querySelectorAll("td.v-data-table__mobile-row");
        row.forEach((td: Element) => {
          // 子要素の「div.v-data-table__mobile-row__header」を探す
          const header = td.querySelector(".v-data-table__mobile-row__header");
          const cell = td.querySelector(".v-data-table__mobile-row__cell");
          if (header && header.textContent?.trim() === "エピソード") {
            // テキストが「エピソード」なら <td> にクラスを付与
            td.classList.add("episode-header");

            if (cell) {
              cell.classList.add("episode-cell");
            }
          }
        });
      });
    },
  },
});
</script>
